import React from 'react'

export default function About() {
  return (
    <div className='container'>
    <h1 className='my-3'>About Us</h1>
       <div className="accordion" id="accordionExample">
  <div className="accordion-item">
    <h2 className="accordion-header">
      <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
      Introduction
      </button>
    </h2>
    <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
      <div className="accordion-body">
        
      Embark on a journey through our narrative where every chapter is a testament to our dedication and zeal. From humble beginnings to remarkable achievements, discover how our commitment to excellence and unyielding passion have shaped our story. It's not just about what we do, but the heart and soul we pour into it.
          </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
      Team and Values
      </button>
    </h2>
    <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
      <div className="accordion-body">
      Meet the brilliant minds and creative hearts that make up our exceptional team. Learn about the values that bind us together, driving us towards a shared vision. Our team members are not just colleagues; they are the pillars of our success. Discover how diversity, collaboration, and a shared sense of purpose define who we are.
          </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 className="accordion-header">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
      Fun with Text Utilities
      </button>
    </h2>
    <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
      <div className="accordion-body">
      In this interactive playground, experience the power of words with our Text Utils. Transform text effortlessly – whether you prefer the bold statement of UPPER CASE or the subtle nuances of lower case. Feeling like sharing your creation? Hit the "Copy to Clipboard" button and spread the creativity. It's a playful twist in an otherwise serious page, adding a touch of interactivity and engagement.
        </div>
    </div>
  </div>
</div>
</div>
  )
}
